import { useFDCNotificationsContext } from '../../FDCNotificationsContext'
import { CIMSTags } from 'components/CIMSTags'
import { useUserTagProps } from 'components/CIMSTags/common/UserTags/hooks/useUserTagProps'
import { CIMSTagsTag } from 'components/CIMSTags/types'
import { ConcurrerTagsProps } from './types'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'

const ConcurrerTags: React.FC<ConcurrerTagsProps> = ({ concurrenceGroup }) => {
  const { data } = useFDCNotificationsContext()
  const help = HelpMessage.FieldDesignChanges.Notifications
  const userTagProps = useUserTagProps()
  const tags = [
    ...(data?.fdcConcurrenceGroups ?? [])
      .filter(({ id }) => {
        if (concurrenceGroup) return concurrenceGroup.id === id
        return true
      })
      .flatMap(({ users }) => users)
      .map(userTagProps),
    ...(data?.fdcConcurrenceGroups ?? [])
      .filter(({ id }) => {
        if (concurrenceGroup) return concurrenceGroup.id === id
        return true
      })
      .flatMap(({ roles }) => roles)
      .map<CIMSTagsTag>(({ name, users }) => ({
        text: name,
        color: 'processing',
        tooltip: `${users.filter(({ deleted }) => !deleted).length} Users`,
      })),
  ]
  const uniqueTags = [...new Set(tags.map((t) => JSON.stringify(t)))].map(
    (s) => JSON.parse(s) as CIMSTagsTag
  )
  if (!uniqueTags.length) return null
  return (
    <CIMSSection
      title="Concurrers"
      help={help.ConcurrenceGroupTags(concurrenceGroup)}
    >
      <CIMSTags tags={uniqueTags} />
    </CIMSSection>
  )
}

export default ConcurrerTags
